//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";

export default BaseCmsBlock.extend({
  name: "FeaturesTextBlock",

  computed: {
    visibleGetIndividualNumber: function () {
      return Boolean(this.$route?.params?.pathMatch === "free-numbers");
    },

    titleTag() {
      return this.values?.title_tag || 'div';
    },
  },

  methods: {
    getIndividualNumber: function () {
      const isUserLogin = Boolean(this.$store.state?.user?.user?.id);

      let utmLabel = "";
      if (this.$i18n.locale === "ru") {
        utmLabel = "?utm_source=free_numbers&utm_medium=ru";
      }
      if (this.$i18n.locale === "en") {
        utmLabel = "?utm_source=free_numbers&utm_medium=en";
      }
      if (this.$i18n.locale === "cn") {
        utmLabel = "?utm_source=free_numbers&utm_medium=cn";
      }

      if (isUserLogin) {
        this.$router.push(this.localePath(`/${utmLabel}`));
      } else {
        this.$router.push(this.localePath(`/registration${utmLabel}`));
      }
    }
  }
})
